// Modal store timeouts
export const MODAL_STORE_OPEN_TIMEOUT = 500;
export const MODAL_STORE_HIGHLIGHT_TIMEOUT = 500;

// Index constants
export const FIRST_INDEX = 0;
export const MODULO_INDEX = 5;

// Transition timeout
export const TRANSITION_TIMEOUT = 300;
